export class BatchSetAPIModel {
  GetBatchSetList: string = "";
  GetBatchSetDetailsById: string = "";
  AddUpdateArticleType: string = "";
  DeleteArticleType: string = "";
  GetBatchNoList: string = "";
  AddBatchSet: string = "";
  GetBatchArticleList: string = "";
  FinalDeliveryRequest: string = "";
  BatchStartProcessRequest: string = "";
}
